import { type FC } from 'react';

import { Flex, HStack, Spacer, Text } from '@chakra-ui/react';
import { useTranslation } from 'react-i18next';

import { IconTrashEmpty } from '../Icons';

type FiltersHeaderProps = {
  filtersAppliedN: number;
  onClear: () => void;
  onClose: () => void;
};

export const FiltersHeader: FC<FiltersHeaderProps> = ({
  filtersAppliedN,
  onClear,
}) => {
  const { t } = useTranslation(['common']);

  return (
    <Flex
      align="center"
      px="14px"
      py="12px"
      bg="gray.50"
      transition="0.2s"
      roundedTop="var(--chakra-radii-xl)"
    >
      <Text color="gray.900">{t('common:filters.filters')}</Text>
      <Spacer />

      <HStack>
        {filtersAppliedN > 0 && (
          <IconTrashEmpty fontSize="20px" cursor="pointer" onClick={onClear} />
        )}
      </HStack>
    </Flex>
  );
};
